import React, { useMemo } from "react"
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import ErrorBoundary from './ErrorBoundary'
import { useLocalization } from 'gatsby-theme-i18n';
import { DateTime } from 'luxon';

const LinkItem = (props) => {

  const { originalPath } = useLocalization();
  const isCurrent = useMemo(() => {
    
    
    if(props.to)
    {
      
      let currentPath = props.to.split('/').splice(2);
      let currentLocation = originalPath.split('/').splice(1);
      
      if(currentPath.length <= 2 && currentPath[0] === currentLocation[0])
        return true;

      if(
        (currentPath.length <=2 && currentPath[0] === "about") && 
        (
          (currentLocation[0] === "ticket") || 
          (currentLocation[0] === "event" && currentLocation[1] === "sponsors")
        )
      )
        return true;
      
      
      if(currentPath.length > 2)
      {
        var match = true;
        for(var i=0;i<currentPath.length;i++)
        {
          if(currentPath[i] !== currentLocation[i])
            match = false;
        }

        return match
      }
         
      //return currentPath.search(originalPath) > -1;
      else
        return false;
    }
  },[originalPath,props.to]);

  
  const className = useMemo(() => {
    let temp = props.className ? props.className : '';
    
    if(isCurrent) 
      temp += ' active';
    
    if(props.updatetime)
    {
      let updateTimeObj = DateTime.fromISO(props.updatetime);
      if(updateTimeObj.diff(DateTime.local(), [ 'days']).values.days > -3)
        temp += ' updated'
    }


    return temp
  },[props.className,props.updatetime,isCurrent])

  return (
    <ErrorBoundary {...props}>
      {props.to ?
        <AniLink {...props} className={className} rel="canonical">{props.children}</AniLink>
      :
        <a {...props} rel="canonical noreferrer noopener" target="_blank">{props.children}</a>
      }
      
    </ErrorBoundary>
  );
};


export default LinkItem;
